import React, { useState } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { AdjustmentStockMultiZone } from '@gull';
import { Modal } from "react-bootstrap";

const ResolveNegativeReassortInterne = (props) =>{
    const t = useTranslate();
    const { posid,wmsid } = useParams();

    const [showModalAjust,setShowModalAjust]=useState(false)
    const [modalInfos,setModalInfos]=useState({
        article:'',
        article_id:'',
        stock_mag:{},
        stock_res:[]
    })

    const doModalAjust = (infos) => {
        setModalInfos({
            article:infos.article_name,
            article_id:infos.article_id,
            stock_mag:infos.commerce,
            stock_res:infos.reserve
        })
        setShowModalAjust(true)
    }

    let sectionid = (props.from=='pos') ? posid : wmsid

    return (
    <div>
        <Modal size="lg" show={showModalAjust} onHide={() => setShowModalAjust(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{t('stockAdjustment')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AdjustmentStockMultiZone articleInfos={modalInfos} sectionid={sectionid} generateRestock={props.generateRestock} setShowModalAjust={setShowModalAjust} from={props.from}/>
            </Modal.Body>
        </Modal>
        {(props.restockState == 'resolve_negative' || props.restockState == 'cant_resolve_negative') ?
            <div className='row mt-4'>
                <div className='col'>
                    <div className='alert alert-danger'>
                        {t('errorStockReassortMsg')}<br />
                        <button 
                            className='btn btn-info mt-2 btn-sm' 
                            onClick={() => {
                                swal
                                .fire({
                                    title: t('confirmGenerateRestockNoReadjust'),
                                    icon: "warning",
                                    type: "question",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: t('btnYes'),
                                    cancelButtonText: t('btnNo'),
                                })
                                .then((result) => {
                                    if (result.value) {
                                        // sectionid et non posid : en contexte WMS, posid est undefined (→ 404)
                                        props.generateRestock('readjustAndNoRestock',sectionid+'/skip')
                                    }
                                });
                            }}
                        
                        >
                            {props.validButton.readjustAndNoRestock ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnReadjustmentAndNoRestock')}
                        </button>
                    </div>
                    <ul className="list-group list-group-flush">
                        {props.reassortToCorrect.map(value=>{
                            let bg = (value.resolve) ? "#ffffbb" : "#fccfcf"

                            return(
                                <li key={value.article_id} style={{backgroundColor:bg}} className="list-group-item mb-1">
                                    <div className='mb-2'>{value.article_name}</div>
                                    <span className='d-block'>{'Stock '+value.commerce.name+' : '+value.commerce.stock}</span>
                                    {value.reserve.map(val=>
                                        <span key={val.id} className='d-block'>{'Stock '+val.name+' : '+val.stock}</span>
                                    )}
                                    <button className='btn btn-primary btn-sm' onClick={() => doModalAjust(value)}>{t('stockAdjustment')}</button>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        :
            (props.restockState == 'no_reassort_needed') ?
                <div className='alert alert-warning'>{t('noRestockNeeded')}</div>
            :
                false
        }

    </div>)
};

export default ResolveNegativeReassortInterne;